export default function PrincipesPedagogiques() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">Principes pédagogiques</h1>
      <div className="mt-6 space-y-4 text-slate-700 leading-relaxed">
        <h2 className="text-xl font-semibold">Une école primaire pas comme les autres</h2>
        <p>La Voie Lactée, créée en 1986, est une école primaire spécialisée subventionnée par la République et le Canton de Genève.</p>
        <p>Il s'agit d'une structure éducative et scolaire qui offre à des enfants qui ont éprouvé des échecs et des blessures dans leur vie affective, sociale et scolaire, un lieu de vie pour réfléchir et apprendre.</p>
        <p>L'école suit le plan d'études romand (Harmos) et pratique la Pédagogie Institutionnelle et les techniques Freinet.</p>
        <p>Par son effectif réduit (35 élèves répartis en 5 groupes-classes), l'école est adaptée à des enfants qui ont besoin d'un suivi personnalisé dans un cadre collectif.</p>
        <h3 className="font-semibold">La Voie Lactée s'adresse à des enfants :</h3>
        <ul className="star-list">
          <li>Avec des difficultés de communication et de langage, des troubles de la personnalité et du comportement.</li>
          <li>Ayant rencontré des difficultés d'adaptation aux exigences du milieu scolaire et de la vie en société.</li>
          <li>Qui ont besoin d'une prise en charge spécifique pour structurer leur rapport au savoir et construire des compétences.</li>
        </ul>
        <h3 className="font-semibold">La pédagogie et ses outils</h3>
        <ul className="star-list">
          <li>Racines dans la Pédagogie Freinet et la Pédagogie Institutionnelle.</li>
          <li>La parole instituée pour favoriser la communication et l'autonomie.</li>
          <li>Un lieu d'apprentissage où la parole de chacun est entendue et respectée.</li>
        </ul>
        <h3 className="font-semibold">Les principes</h3>
        <ul className="star-list">
          <li>L'enfant est une personne.</li>
          <li>L'épanouissement est un droit.</li>
          <li>Chaque enfant a droit à l'éducation, à l'instruction et à la formation.</li>
          <li>Le savoir est un moyen d'émancipation.</li>
        </ul>
        <h3 className="font-semibold">Organisation de la vie scolaire</h3>
        <ul className="star-list">
          <li>35 élèves en 5 groupes-classes, ateliers décloisonnés et ateliers de création.</li>
          <li>Prises en charge pédago-thérapeutiques: logopédie, musicothérapie, sport, jeux collectifs, corps & mouvements.</li>
          <li>Horaire continu 8 h 15 – 15 h 45, transport organisé, repas au restaurant scolaire des Vergers.</li>
        </ul>
      </div>
    </main>
  );
}
